import { render, staticRenderFns } from "./addInfo.vue?vue&type=template&id=0cb2a912"
import script from "./addInfo.vue?vue&type=script&lang=js"
export * from "./addInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports